var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fade-in-fwd", attrs: { id: "step-projects" } },
    [
      _c("div", { staticClass: "row mb-2" }, [
        _c(
          "div",
          { class: _vm.isCreateProjectAreaActive ? "col-md-7" : "col-md-6" },
          [
            _vm.isCreateProjectAreaActive
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newProjectText,
                      expression: "newProjectText"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    placeholder:
                      _vm.$resourceString[
                        "myProject.Project.CreateModal.ProjectName.Placeholder"
                      ]
                  },
                  domProps: { value: _vm.newProjectText },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.newProjectText = $event.target.value
                      },
                      _vm.setNewProjectText
                    ]
                  }
                })
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        !_vm.isCreateProjectAreaActive
          ? _c("div", { staticClass: "col-md-6" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary add-button float-sm-right",
                  on: {
                    click: function($event) {
                      _vm.isCreateProjectAreaActive = true
                    }
                  }
                },
                [
                  _c("span", {
                    staticClass: "png-icon png-icon-icons-glyph--ko-plus mr-2"
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$resourceString[
                          "myProject.Project.NewProject.Title"
                        ]
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          : _c("div", { staticClass: "col-md-5" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary add-button w-100 d-block",
                  on: { click: _vm.createProject }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$resourceString[
                          "myProject.Project.CreateModal.CreateProject.Button"
                        ]
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "input-group border border-light mb-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchtext,
                  expression: "searchtext"
                }
              ],
              staticClass: "form-control border-0",
              attrs: {
                type: "search",
                placeholder:
                  _vm.$resourceString[
                    "account.MyProject.SearchField.Placeholder"
                  ]
              },
              domProps: { value: _vm.searchtext },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchtext = $event.target.value
                  },
                  _vm.updateSearchQuery
                ],
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.submitSearch($event)
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-prepend" }, [
              _c(
                "button",
                {
                  staticClass: "btn px-1 p-1",
                  attrs: { tabindex: "-1", type: "submit" },
                  on: { click: _vm.submitSearch }
                },
                [
                  _c("span", {
                    staticClass: "png-icon png-icon-icons-glyph--k-search"
                  })
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.getContentWizardData.allProjects.length > 0
        ? _c(
            "div",
            {
              staticClass: "row mt-2",
              class:
                _vm.getContentWizardData.allProjects.length > 3
                  ? "inspiration-gallery-item-container"
                  : "",
              attrs: { id: "list-of-projects" }
            },
            [
              _vm._l(_vm.getContentWizardData.allProjects, function(
                item,
                index
              ) {
                return _c("div", { key: index, staticClass: "col-sm-4 mt-2" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "swiper-slide swiper-slide-visible swiper-slide-active mb-2",
                      class:
                        item.id == _vm.getContentWizardData.chosenProject.id
                          ? "my-project-feature-image-active"
                          : "",
                      on: {
                        click: function($event) {
                          return _vm.selectProject(item)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "wf-product-quick-view-swatch-slide" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "wf-product-quick-view-swatch-slide-image"
                            },
                            [
                              _c("img", {
                                staticClass: "room-img-thumb",
                                style: {
                                  backgroundColor: item.coverPhoto
                                    ? ""
                                    : "#9f9e9e"
                                },
                                attrs: {
                                  src: item.coverPhoto,
                                  alt: item.title || ""
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "medium mb-2 px-2 w-100 text-size-xsmall text-left"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.title) +
                              "\n                "
                          )
                        ]
                      )
                    ]
                  )
                ])
              }),
              _vm._v(" "),
              _vm.showLoadMore
                ? _c("pc-load-more", { attrs: { "load-more": _vm.onLoadMore } })
                : _vm._e(),
              _vm._v(" "),
              _vm.getContentWizardData.allProjects.length == 0 &&
              !_vm.showLoadMore
                ? _c("div", { staticClass: "container" }, [
                    _c("p", {}, [
                      _vm._v(
                        _vm._s(
                          _vm.$resourceString["common.NoDataAvailable.Msg"]
                        )
                      )
                    ])
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }